<template>
	<v-switch
		v-model="swit.value"
		:label="swit.value ? swit.truelabel : swit.falselabel"
		:color="swit.color !== undefined ? swit.color : $store.state.PointColor1"
		:class="swit.class"
		:value="swit.detailcode"
		dense
		:error-messages="swit.errorMessage"
		:hide-details="swit.hideDetail"
		@click="$emit('click')"
		:disabled="disable"
	>
	</v-switch>
</template>

<script>
export default {
	props: {
		swit: Object,
		disable: Boolean,
	},
	methods: {
		changeDummy() {},
	},
}
</script>

<style></style>
